export default "__VITE_ASSET__D$p_cpCP__"